<template>
  <nav class="bottom-nav">
    <router-link to="/home">
      <div class="link-content">
        <el-icon class="icon bottom-nav-icon">
          <HomeFilled />
        </el-icon>
        <span class="text">首页</span>
      </div>
    </router-link>
    <router-link to="/organize">
      <div class="link-content">
        <el-icon class="icon bottom-nav-icon">
          <Management />
        </el-icon>
        <span class="text">组织生活</span>
      </div>
    </router-link>
    <!-- <router-link to="/activity">
      <div class="link-content">
        <el-icon class="icon bottom-nav-icon">
          <Flag />
        </el-icon>
        <span class="text">活动</span>
      </div>
    </router-link> -->
    <router-link to="/mine">
      <div class="link-content">
        <el-icon class="icon bottom-nav-icon">
          <UserFilled />
        </el-icon>
        <span class="text">我的</span>
      </div>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  bottom: -0.15vw;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: space-around;
  padding: 2.5641vw 0 1.28205vw 0;
  background-color: white;
  border-top: 0.25641vw solid #f1f1f1;
  z-index: 100;
}

.bottom-nav-icon {
  font-size: 6.15385vw;
}

.link-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #666;
}

.text {
  font-size: 3.58974vw;
}

.router-link-active .icon {
  color: #ff6060;
}

.router-link-active {
  font-weight: bold;
}
</style>